import axiosInstance from '@/axiosInstance'
import { getApiUrl } from '@/helper'
import { URL } from '../../constatns'

export const loadExtended = (payload) => {
  return axiosInstance.post(`${getApiUrl()}${URL}/extended`, { data: payload })
}
